<ui-title [title]="'User Roles Auto Rec'"></ui-title>


<div class="card">
	<div class="card-header">
		<h2>Role Groups Setup</h2>
	</div>
	<div class="card-body">
		<div>

			<div class="row">
				<div class="col-lg-8">
					<ui-loading [loading]="roles.loading" [loadingText]="'loading roles'"></ui-loading>
					<ui-table [chunker]="roles.chunker" (chunked)="roles.chunkedData = $event" [headers]="roles.tableHeaders" [filters]="true">
						<tr *ngFor="let role of roles.chunkedData"
							[class]="roles.selectedId==role.Id?'helper-clickable active':'helper-clickable'"
							(click)="roles_onRowClick(role)"
						>
							<td style="width: 20%">{{ role.System.Name }}</td>
							<td style="width: 20%">{{ role.Name }}</td>
							<td style="width: 30%">{{ role.MappedName }}</td>
							<td style="width: 20%">
								<div *ngFor="let g of  role.AssignedGroups" class="badge bg-grey me-1">{{ g.RoleGroup.Name }}</div>
							</td>
							<td style="width: 10%">
								{{ helper_countAssignedGroups(role) }}
							</td>
						</tr>
					</ui-table>
				</div>

				<div class="col-lg-4">
					<ui-loading [loading]="roles.loadingSelected"></ui-loading>
					<div class="card" *ngIf="roles.selected.Id">
						<div class="card-header">
							<div>
								<h2>{{ roles.selected.Name }} <small style="font-size: 12px;">{{ roles.selected.System.Name }}</small></h2>
							</div>
						</div>
						<div class="card-body">
							<ui-loading [loading]="groups.loading" [loadingText]="'loading role groups'"></ui-loading>
							<div *ngFor="let g of  groups.data">
								<ui-input-checkbox [(ngModel)]="roles.assignedGroups[g.Id]" [metadata]="{label:g.Id+' '+g.Name}"></ui-input-checkbox>
							</div>
							<button class="btn btn-primary" type="button" (click)="role_save()">Save</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="card-separator"></div>

<div class="card">
	<div class="card-header">
		<h2>Automatic Reconciliation</h2>
	</div>
	<div class="card-body">
		<ui-loading [loading]="systems.loading" [loadingText]="'loading systems'"></ui-loading>
		<div *ngIf="!systems.loading">
			<div class="form-group row">
				<label class="col-lg-2 col-form-label">
					System
				</label>
				<div class="col-lg-10">
					<select [(ngModel)]="systems.selectedId" class="form-control" name="selectedsystemid">
						<option value="0">All</option>
						<option *ngFor="let s of systems.data" [value]="s.Id">{{ s.Name }}</option>
					</select>
				</div>
			</div>
			<button type="button" class="btn btn-primary" (click)="rec_start()">Auto Reconcile</button>
		</div>
	</div>

	<div class="card-body" *ngIf="rec.done">
		<ui-table [chunker]="rec.chunker" (chunked)="rec.chunkedData = $event" [headers]="rec.tableHeaders" [filters]="true" [options]="{paginationCountSelector:true}">
			<tr *ngFor="let r of rec.chunkedData" class="helper-clickable">
				<td>

						{{ r.User.FirstName }} {{ r.User.LastName }}

				</td>
				<td>
					<div (click)="groups_selectForUser(r)">
						<span *ngIf="!r.ActualRolesNames || !r.ActualRolesNames.length" class="btn btn-sm bg-grey-important"  style="font-size: 10px">(no role)</span>
						<ng-container *ngIf="r.ActualRolesNames && r.ActualRolesNames.length>0">
								<span *ngFor="let g of r.ActualRolesNames" class="btn btn-sm bg-grey-important"  style="font-size: 10px;margin-right: 2px;">
									{{ g }}
								</span>
						</ng-container>
					</div>
				</td>
				<td>{{ r.User.Title }}</td>
				<td><button class="btn btn-sm bg-grey-important" style="font-size: 10px" (click)="rec_details(r)">{{ r.RoleIds.length }}</button></td>
				<th *ngFor="let g of groups.data">
					<span *ngIf="r.GroupIdCount[g.Id]">
						{{ r.GroupIdCount[g.Id] }}
					</span>
				</th>
				<th>{{ rec_isRowSuspect(r) }}</th>
			</tr>
		</ui-table>
	</div>
</div>

<ui-modal [title]="'User roles'" [lg]="true" [class]="'with-scroll'" [(isHidden)]="groups.modalIsHidden">
	<div class="card">
		<div class="card-body">
			<ui-loading *ngIf="groups.userSaving"></ui-loading>
			<div class="table ui-table table-condensed" *ngIf="!groups.userSaving">
				<div *ngFor="let g of groups.data">
						<ui-input-checkbox name="{{g.Name}}" [(ngModel)]="groups.userRoles[g.Id]"></ui-input-checkbox>
				</div>
			</div>
			<div class="btn btn-primary" (click)="groups_saveSelectionForUser()">Save</div>
		</div>
	</div>
</ui-modal>


<ui-modal [title]="'Details '+rec.selected.User?.FirstName+' '+rec.selected.User?.LastName" [(isHidden)]="rec.modalHidden" [lg]="true" [class]="'with-scroll'">
	<div class="card" *ngIf="rec.selected.User">
		<div class="card-body">
			<div *ngFor="let groupKV of rec.selected.GroupIdCount|kv">
				<div>
					{{ groups.byId[helper_asInt(groupKV.key)].Name }}: {{ groupKV.value }} roles
				</div>
			</div>
		</div>
		<div class="card-body">
			<table class="table ui-table table-condensed">
				<tr>
					<th>System</th>
					<th>Role Name</th>
					<th>Standard Role Name</th>
					<th>Role Groups</th>
				</tr>
				<tr *ngFor="let roleId of rec.selected.RoleIds">

					<td>{{ roles.byId[roleId].System.Name }}</td>
					<td>{{ roles.byId[roleId].Name }}</td>
					<td>{{ roles.byId[roleId].MappedName }}</td>

					<td>
						<div *ngFor="let g of roles.byId[roleId].AssignedGroups" class="badge {{rec_userHasRole(g.RoleGroup.Id,g.RoleGroup.Name)?'bg-green-important':'bg-grey-important'}} me-1" >
							{{ g.RoleGroup.Name }}
						</div>
					</td>
				</tr>
			</table>
		</div>
	</div>
</ui-modal>
